import useAuthTeam from '@apps/www/src/www/hooks/useAuthTeam';

const useTeamHomePath = () => {
	const team = useAuthTeam();

	if (!team) {
		return '/';
	}

	return team.teamFeedAsHomepage ? '/' : '/team';
};

export default useTeamHomePath;
